import React from 'react'

import { ForAccountType } from '../components/Auth/ForAccountType'
import { UsersList } from '../components/Users/ListUsers'
import { AccountTypePermissions } from '../domain/account-type.domain'

import { Page } from './shared/Page'

export const ManageUsersPage: React.FC = () => {
    return (
        <ForAccountType permission={AccountTypePermissions.UserList}>
            <Page>
                <UsersList />
            </Page>
        </ForAccountType>
    )
}
